import React from 'react';
import { SectionLabel } from './SectionLabel';
type PageHeroProps = {
  eyebrow: string;
  title: string;
  lede: string;
  aside?: React.ReactNode;
};
export function PageHero({
  eyebrow,
  title,
  lede,
  aside
}: PageHeroProps) {
  return <section className="border-b border-ink-100 bg-ink-950" data-id="element-104" data-mp="3tbd6ale5lp0y">
      <div className="mx-auto max-w-container px-6 py-20 lg:px-10 lg:py-28" data-id="element-105" data-mp="22zajrx1q6yk">
        <SectionLabel tone="dark" data-id="element-106" data-mp="pt3b1qextqlc">{eyebrow}</SectionLabel>
        <div className="mt-8 grid gap-10 lg:grid-cols-[1.35fr_1fr] lg:items-end" data-id="element-107" data-mp="ptlhffvbdl6z">
          <h1 className="max-w-3xl text-4xl font-semibold leading-[1.05] tracking-tightest text-white sm:text-5xl lg:text-6xl" data-id="element-108" data-mp="ur4yenjecc2m">
            {title}
          </h1>
          <div data-id="element-109" data-mp="l23gusx7dmmj">
            <p className="max-w-md text-base leading-relaxed text-ink-300 lg:text-lg" data-id="element-110" data-mp="l1lcf90e023j">
              {lede}
            </p>
            {aside && <div className="mt-6" data-id="element-111" data-mp="18qee7m3ox462">{aside}</div>}
          </div>
        </div>
      </div>
    </section>;
}